import { Controller } from "@hotwired/stimulus"

// Locks page scrolling while the mobile nav overlay is open so the content
// underneath can't scroll behind it (which caused flickers and scrollbar
// activation). The reveal controller toggles the `hidden` class on this
// element; we watch for that and mirror the state onto the <body>.
//
// The lock uses the `max-md:overflow-hidden` utility, so it only takes effect
// below the `md` breakpoint — on larger screens the full-screen menu never
// shows and the page stays scrollable.
export default class extends Controller {
  static classes = ["lock"]

  connect() {
    this.observer = new MutationObserver(() => this.sync())
    this.observer.observe(this.element, {
      attributes: true,
      attributeFilter: ["class"],
    })
    this.sync()
  }

  disconnect() {
    this.observer.disconnect()
    this.unlock()
  }

  sync() {
    if (this.element.classList.contains("hidden")) {
      this.unlock()
    } else {
      this.lock()
    }
  }

  lock() {
    document.body.classList.add(...this.lockClasses)
  }

  unlock() {
    document.body.classList.remove(...this.lockClasses)
  }
}
